import * as models from "../models";

export const CONTENT_TYPE_JSON: string = "application/json";
export const CONTENT_TYPE_FORM: string = "application/x-www-form-urlencoded; charset=UTF-8";

export const REGEX_DATE = /\d{2}(\.)\d{2}(\.)\d{4}/g;
export const REGEX_DATE_ISO = /^(\d{4}\-\d\d\-\d\d([tT][\d:\.]*)?)([zZ]|([+\-])(\d\d):(\d\d))?$/g;
/*
    ^           Start of string (anchor)
    (           begin capturing group
    [01]        a "0" or "1"
    \d          any digit
    |           or
    2[0-3]      "2" followed by a character between 0 and 3 inclusive
    )           end capturing group
    :           colon
    (           start capturing
    [0-5]       character between 0 and 5
    \d          digit
    )           end group
    :?          optional colon
    (           start capturing
    [0-5]       character between 0 and 5
    \d          digit
    )           end group
    ?           group is optional
    $           end of string anchor
*/
export const REGEX_TIME = /^([01]\d|2[0-3]):([0-5]\d):?([0-5]\d)?$/g;
export const REGEX_NUMBER = /^-?\d+\.?\d*$/g;

export const DEFAULT_EVENT_COLOR: string = "#9E9E9E";
export const DEFAULT_LOCK_COLOR: string = "#df4019";
export const CALENDAR_COLORS: models.IColor[] = [
    { name: "blue", color: "#0079bf" },
    { name: "orange", color: "#d29034" },
    { name: "green", color: "#519839" },
    { name: "red", color: "#b04632" },
    { name: "purple", color: "#89609e" },
    { name: "pink", color: "#cd5a91" },
    { name: "lime", color: "#4bbf6b" },
    { name: "sky", color: "#00aecc" },
    { name: "null", color: "#A4A4A4" }
];
export const LABEL_COLORS: models.IColor[] = [
    { name: "green", color: "#61BD4F" },
    { name: "yellow", color: "#F2D600" },
    { name: "orange", color: "#FFAB4A" },
    { name: "red", color: "#EB5A46" },
    { name: "purple", color: "#C377E0" },
    { name: "blue", color: "#0079BF" },
    { name: "sky", color: "#00C2E0" },
    { name: "lime", color: "#51E898" },
    { name: "pink", color: "#FF80CE" },
    { name: "black", color: "#4d4d4d" },
    { name: "null", color: "#B6BBBF" }
];
export const LABEL_PATTERNS: models.IColor[] = [
    { name: "pattern1", color: "pattern1" },
    { name: "pattern2", color: "pattern2" },
    { name: "pattern3", color: "pattern3" }
];

export const STORAGE_KEYS = {
    flyoutHome: "fo-home",
    flyoutSettings: "fo-settings",
    calendar: "calendar"
};